<app-file-upload-modal-layout
  [title]="'Upload New Public SFTP Key'"
  [isUploadButtonBusy]="isUploadButtonBusy()"
  [isUploadButtonDisabled]="isUploadButtonDisabled()"
  [isCancelButtonDisabled]="isCancelButtonDisabled()"
  [isCloseIconDisabled]="isCloseIconDisabled()"
  [isFileUploading]="fileUploading"
  (actionButtonClick)="onButtonClick($event)"
  (closeIconClick)="onCloseIconClick()"
>
  <div class="file-upload-modal__left-section file-upload-modal__file-details">
    <div class="file-upload-modal__drag-and-drop-container">
      <app-drag-and-drop-file
        [invalidFiles]="isUploadedFileInvalid()"
        [fileName]="selectedFile?.name"
        (clearFiles)="clearFile()"
        (filesChange)="onFileSelect($event)"
      >
      </app-drag-and-drop-file>
    </div>
  </div>

  <div class="file-upload-modal__right-section file-upload-modal__preview">
    <span class="file-upload-modal__preview-title">Preview</span>

    <ng-template [ngIf]="newPublicKey" [ngIfElse]="noSHHKey">
      <lib-text-area
        class="file-upload-modal__preview-text-area"
        *ngIf="newPublicKey"
        [disabled]="true"
        [value]="newPublicKey"
      >
      </lib-text-area>
    </ng-template>

    <ng-template #noSHHKey>
      <span>--</span>
    </ng-template>
  </div>
</app-file-upload-modal-layout>
